// extracted by mini-css-extract-plugin
module.exports = {"body":"CreateOrg_body__3Q3jC"};